export default {
	namespaced: true,
	state: {
		items: [
            { url: {name: 'profitability'}, text: 'Доходность', class: 'icon-chartup'},
            { url: {name: 'chat'}, text: 'Чат', class: 'icon-chat'},
			{ url: {name: 'statistic'}, text: 'Статистика', class: 'icon-chart'},
			{ url: {name: 'blog'}, text: 'Блог', class: 'icon-edit'},
			//{ url: {name: 'managment'}, text: 'Доверительное управление', class: 'icon-briefcase-check'},
            { url: {name: 'profile'}, text: 'Доверительно управляющий', class: 'icon-user'},
            { url: {name: 'investing'}, text: 'Инвестировать', class: 'icon-coin'},
            { url: {name: 'signals'}, text: 'Торговые сигналы', class: 'icon-users'}
        ],
        personal : [
            {url: {name: 'personal'}}
        ],
        tabFullScreens : [
            {url: {name: 'chart'}, link:'', linkComp: 'fullscreen'}
        ],
	},
	getters: {
		items(state) {
			return state.items
        },
        personal(state) {
            return state.personal
        },
        screen(state) {
            return state.tabFullScreens
        }
	}
}
